<template>
    <div class="main__learner__data__section common__page__box">
        <div class="rlms-container organizations-list">
            <div class="rlms-flex rlms-flex-col rlms-height-full rlms-justify-between"
                style="margin-top: var(--header-height);">
                <div class="rlms-w-100">
                    <!-- Organization data loaded -->
                    <div class="rlms-bg-white rlms-p-desk30-mob-20 rlms-br-20 bg-min-height">
                        <div class="rlms-flex rlms-flex-col rlms-gap-desk30-mob-20">
                            <template v-if="loading">
                                <div
                                    class="rlms-flex rlms-items-center rlms-justify-between rlms-flex-wrap rlms-gap-10">
                                    <div class="rlms-fs-lg rlms-fw-600">My Organizations</div>
                                    <button class="rlms-btn rlms-btn-primary" @click="openAddEditOrganization">
                                        Add New Organization
                                    </button>
                                </div>
                                <div class="rlms-table">
                                    <div class="rlms-table-inner">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>EESA Regressions</th>
                                                    <th>Created</th>
                                                    <th>Learners Count</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td colspan="5">
                                                        <SkeletonLoader />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <template v-if="organizations.length > 0">
                                    <div
                                        class="rlms-flex rlms-items-center rlms-justify-between rlms-flex-wrap rlms-gap-10">
                                        <div class="rlms-flex rlms-items-center rlms-gap-10">
                                            <div class="rlms-fs-lg rlms-fw-600">My Organizations</div>
                                            <div class="video__info__btn__item transcription-setting" style="padding: 0;">
                                                <a href="https://www.youtube.com/watch?v=ZX-683XpOSU" class="popup-youtube rlms-flex rlms-items-center">
                                                    <span class="badge rlms-fw-600 rlms-flex rlms-items-center rlms-gap-5">
                                                        <span class="material-symbols-outlined">help</span> Help
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                        <button class="rlms-btn rlms-btn-primary" @click="openAddEditOrganization">
                                            Add New Organization
                                        </button>
                                    </div>

                                    <div class="rlms-table">
                                        <div class="rlms-table-inner">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>EESA Regressions</th>
                                                        <th>Created</th>
                                                        <th>Learners Count</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="organization in organizations" :key="organization.id">
                                                        <td>
                                                            <div
                                                                class="rlms-flex rlms-items-center rlms-gap-10 rlms-w-mc">
                                                                <img :src="buildingSvg">
                                                                <p class="rlms-fw-500">{{ organization.name }}</p>
                                                                <template v-if="!organization?.is_owner && organization?.is_administrator">
                                                                    <Tooltip :content="`<p class='rlms-p-3'>Administrator Access</p>`" placement="bottom">
                                                                        <template #button>
                                                                            <img :src="optionsInfoIcon"/>
                                                                        </template>
                                                                    </Tooltip>
                                                                </template>
                                                            </div>
                                                        </td>
                                                        <td>{{ organization.regressions === 1 ? 'Yes' : 'No' }}</td>
                                                        <td>
                                                            <p class="rlms-text-secondary-lighter">{{
                                                                formatDate(organization.created_at) }}</p>
                                                        </td>
                                                        <td>{{ organization.learners_count }}</td>
                                                        <td>
                                                            <RouterLink
                                                                :to="`/organizations/${organization.id}/overview`"
                                                                class="rlms-flex rlms-items-center rlms-gap-5 rlms-cursor-pointer">
                                                                <img :src="eyeSvg">
                                                                <p class="rlms-text-primary-500">View</p>
                                                            </RouterLink>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="rlms-flex rlms-flex-col rlms-gap-desk30-mob-20 rlms-items-center">
                                        <div class="rlms-text-center rlms-fw-700 rlms-fs-lg">Create Organization</div>
                                        <div data-v-13398759="" class="rlms-border-bottom rlms-w-100"></div>
                                        <div style="min-height: 600px;"
                                            class="rlms-flex rlms-flex-col rlms-gap-desk30-mob-20 rlms-justify-center rlms-items-center">
                                            <img :src="kigReadingBookImg" width="300">
                                            <div class="rlms-fw-600 rlms-fs-md">No Organizations</div>
                                            <p class="rlms-text-center" style="max-width: 604px;">An organization is a space to manage learners and groups. Purchases are tied to the organization where they were made and can't be transferred. If you're part of a company, check with them before creating one to avoid duplicates.</p>
                                            <div class="video__info__btn__item transcription-setting">
                                                <a href="https://www.youtube.com/watch?v=ZX-683XpOSU" class="popup-youtube rlms-flex rlms-items-center">
                                                    <span class="badge rlms-fw-600 rlms-flex rlms-items-center rlms-gap-5">
                                                        <span class="material-symbols-outlined">help</span> Help
                                                    </span>
                                                </a>
                                            </div>
                                            <button class="rlms-btn rlms-btn-primary" @click="openAddEditOrganization">
                                                Add New Organization
                                            </button>
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <AddEditOrganizationModal v-if="showOrganizationModal" @close="showOrganizationModal = false;"
                @saved="init()" />
        </div>
    </div>
</template>
<script setup>
import { ref, onMounted, computed } from 'vue';
import axios from "@/services/axios";
import kigReadingBookImg from "@/assets/images/kids-reading-book.png";
import buildingSvg from "@/assets/images/building.svg";
import eyeSvg from "@/assets/images/eye.svg";
import { formatDate } from '@/utils/format-helpers';
import AddEditOrganizationModal from '@/components/AddEditOrganizationModal.vue';
import { handleError } from '@/utils/handleError';
import { useLoaderStore } from '@/stores/loader';
import SkeletonLoader from '@/components/skeleton/SkeletonLoader.vue';
import Tooltip from '@/components/Tooltip.vue';
import optionsInfoIcon from '@/assets/images/options-info-icon.png';
import $ from 'jquery';
import 'magnific-popup';
import 'magnific-popup/dist/magnific-popup.css';

const loader = useLoaderStore();

const organizations = ref([]);
const showOrganizationModal = ref(false);

const loading = computed(() => {
    return loader.loading;
});

onMounted(async () => {
    init();

    // Wait for data to load and DOM to update, then initialize popup
    setTimeout(() => {
        const $popupElements = $('.popup-youtube');
        if ($popupElements.length > 0) {
            $popupElements.magnificPopup({
                type: 'iframe',
                mainClass: 'mfp-fade',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false
            });
        }
    }, 2000);
});

const init = () => {
    showOrganizationModal.value = false;
    fetchOrganizations();
}

const fetchOrganizations = async () => {
    try {
        loader.show();
        const { data } = await axios.get('/organizations');

        organizations.value = data.data;
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
}

const openAddEditOrganization = () => {
    showOrganizationModal.value = true;
}
</script>